"use client"

export function UIProvider({ children }: { children: React.ReactNode }) {
  return children
}
